import React, { useEffect, useId, useRef } from "react";
import Button from "../../ui/Button";
import DrawerA11yWrapper from "../../ui/DrawerA11yWrapper";
import { colors, radius, shadows, spacing, typography } from "../../ui/tokens";
import AuditUniverseDetail from "./AuditUniverseDetail";

const ensureAuditUniverseDrawerAnimations = (() => {
  let injected = false;
  return () => {
    if (injected) return;
    const styleTag = document.createElement("style");
    styleTag.setAttribute("data-audit-universe-drawer", "true");
    styleTag.innerHTML = `
@keyframes auditUniverseDrawerSlide {
  from { transform: translateX(40px); opacity: 0; }
  to { transform: translateX(0); opacity: 1; }
}

@keyframes auditUniverseDrawerFade {
  from { opacity: 0; }
  to { opacity: 1; }
}
`;
    document.head.appendChild(styleTag);
    injected = true;
  };
})();

export default function AuditUniverseDetailDrawer({ auditUniverseId, onClose }) {
  const titleId = useId();
  const closeRef = useRef(null);

  useEffect(() => {
    ensureAuditUniverseDrawerAnimations();
  }, []);

  if (!auditUniverseId) return null;

  return (
    <DrawerA11yWrapper
      open={Boolean(auditUniverseId)}
      onClose={onClose}
      labelledBy={titleId}
      initialFocusRef={closeRef}
      backdropStyle={overlayStyle}
      containerStyle={drawerStyle}
    >
      <div style={layoutStyle}>
        <div style={headerStyle}>
          <div id={titleId} style={{ fontSize: typography.size.lg, fontWeight: typography.weight.medium }}>
            Auditable Entity Details
          </div>
          <Button
            onClick={onClose}
            variant="ghost"
            style={closeButtonStyle}
            aria-label="Close auditable entity drawer"
            ref={closeRef}
          >
            ×
          </Button>
        </div>
        <div style={contentStyle}>
          <AuditUniverseDetail auditUniverseId={auditUniverseId} inline />
        </div>
      </div>
    </DrawerA11yWrapper>
  );
}

const overlayStyle = {
  position: "fixed",
  inset: 0,
  background: colors.overlayBackdrop,
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "stretch",
  zIndex: 3000,
  animation: "auditUniverseDrawerFade 0.2s ease-out",
};

const drawerStyle = {
  width: "560px",
  maxWidth: "92vw",
  height: "100%",
  background: colors.surface,
  display: "flex",
  flexDirection: "column",
  boxShadow: shadows.lg,
  animation: "auditUniverseDrawerSlide 0.25s ease-out",
};

const layoutStyle = {
  height: "100%",
  display: "flex",
  flexDirection: "column",
};

const headerStyle = {
  padding: `${spacing.xl + spacing.sm}px ${spacing.xl * 2 - spacing.xs}px`,
  borderBottom: `1px solid ${colors.border}`,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  background: colors.surface,
  position: "sticky",
  top: 0,
  zIndex: 10,
};

const closeButtonStyle = {
  background: "transparent",
  border: "none",
  cursor: "pointer",
  fontSize: `${typography.size.lg}px`,
  color: colors.textMuted,
  padding: "4px 8px",
  borderRadius: radius.sm,
};

const contentStyle = {
  padding: `${spacing.xl}px ${spacing.xl + spacing.sm}px`,
  overflowY: "auto",
  flex: 1,
};
